import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const twoFactorService = {
  // Initialize 2FA setup with chosen method
  setup2FA: async (method) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/accounts/setup-2fa/`,
        { method },
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error("Error setting up 2FA:", error);
      throw error;
    }
  },

  // Generate new SMS code
  generateSMSCode: async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/accounts/generate/two-fa/otp/`,
        {},
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error("Error generating SMS code:", error);
      throw error;
    }
  },

  // Enable authenticator after initial setup
  enableAuthenticator: async (code) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/accounts/enable-authenticator/`,
        { code },
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error("Error enabling authenticator:", error);
      throw error;
    }
  },

  // Verify 2FA code (works for both SMS and authenticator)
  verify2FA: async (method, code) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/accounts/verify-2fa/`,
        { method, code },
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error("Error verifying 2FA code:", error);
      throw error;
    }
  },

  // Get 2FA status for user
  get2FAStatus: async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/accounts/2fa-status/`,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error getting 2FA status:", error);
      throw error;
    }
  },
  delete2FAStatus: async () => {
    try {
      const response = await axios.delete(
        `${baseUrl}/api/accounts/2fa-delete/`,
        getConfig()
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting 2FA status:", error);
      throw error;
    }
  },
};

export const check2FARequired = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/accounts/auth/check-2fa`,
      getConfig()
    );
    return response.data;
  } catch (error) {
    console.error("Error checking 2FA status:", error);
    throw error;
  }
};

export const requestLoginSMSCode = async () => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/accounts/auth/request-sms`,
      {},
      getConfig()
    );
    return response.data;
  } catch (error) {
    console.error("Error requesting SMS code:", error);
    throw error;
  }
};

export const verify2FALogin = async (method, code) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/accounts/auth/verify-2fa`,
      { method, code },
      getConfig()
    );
    return response.data;
  } catch (error) {
    console.error("Error verifying 2FA code:", error);
    throw error;
  }
};
